<template>
  <v-dialog :value="value" persistent scrollable :width="640">
    <v-card>
      <v-card-text v-if="loading">
        <ScaleLoader :color="$vuetify.theme.primary" />
      </v-card-text>
      <template v-else>
        <v-card-title>
          <div v-if="title" class="headline">{{ title }}</div>
          <v-spacer />
          <v-btn icon flat @click="$emit('input', false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <slot />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="$emit('input', false)">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" @click="$emit('submit', () => $emit('input', false))">
            {{ $t('Save') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  components: { ScaleLoader },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/ExecutiveManagement/UserFormDialog.vue